import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const RefreshIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    width: 20,
    height: 20,
    ...props,
  };
  return (
    <svg
      className="w-6 h-6"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <polygon
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        points="21,9 27,3 28,10 "
      />
      <polygon
        fill={color}
        points="21,9 27,3 28,10 "
        data-cap="butt"
        data-stroke="none"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeMiterlimit={10}
        d="M3,16C3,8.82,8.82,3,16,3 c3.493,0,6.665,1.378,9.001,3.62"
        data-cap="butt"
      />
      <polygon
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        points="11,23 5,29 4,22 "
        data-color="color-2"
      />
      <polygon
        fill={color}
        points="11,23 5,29 4,22 "
        data-cap="butt"
        data-color="color-2"
        data-stroke="none"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeMiterlimit={10}
        d="M29,16c0,7.18-5.82,13-13,13 c-3.493,0-6.665-1.378-9.001-3.62"
        data-cap="butt"
        data-color="color-2"
      />
    </svg>
  );
};
